import { useCallback } from 'react';
import { useAppStore } from 'store/hooks';
import { Tier } from 'features/premium/entities';
import { selectUserTier } from 'features/premium/selectors/tier';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { selectInterestInfoForProductId, selectPotProductFromProductId } from '../reducers/selectors';
/**
 * Interest pots show the rate upgrade screen first, unless the user is already on Ultimate
 * or there is no better rate to upgrade to. Everything else goes straight to CreatePot.
 */
const useNavigateToCreatePot = () => {
    const store = useAppStore();
    const navigation = useMainStackNavigation();
    const navigateToCreatePot = useCallback((productId, { replace = false } = {}) => {
        const state = store.getState();
        const potType = selectPotProductFromProductId(state, productId)?.type;
        const { hasRateUpgrade } = selectInterestInfoForProductId(state, productId);
        const isInterestPot = potType === 'INTEREST' || potType === 'INTEREST_NOTICE';
        const showRateUpgrade = isInterestPot && selectUserTier(state) !== Tier.ultimate && hasRateUpgrade;
        const routeName = showRateUpgrade ? 'PotInterestRates' : 'CreatePot';
        if (replace) {
            navigation.replace(routeName, { productId });
        }
        else {
            navigation.navigate(routeName, { productId });
        }
    }, [navigation, store]);
    return navigateToCreatePot;
};
export default useNavigateToCreatePot;
